import React from 'react';
import AuraCardShell from './AuraCardShell';
import { AuraFormattedText } from './AuraFormattedText';

const ProgressCardContent = ({ card }) => {
  const metric = card.metric_type;
  const payload = card.payload || {};

  return (
    <AuraCardShell type="progress" title={card.title} badge="Progress">
      {card.message && (
        <p className="text-body text-ink-muted mb-3">
          <AuraFormattedText content={card.message} />
        </p>
      )}

      {metric === 'vision_goal' && payload.percent != null && (
        <div>
          <div className="flex justify-between text-label text-ink-muted mb-1">
            <span className="figure">{payload.percent}% there</span>
            {payload.on_pace_for_date && (
              <span>On pace for {String(payload.on_pace_for_date).slice(0, 10)}</span>
            )}
          </div>
          <div className="h-1.5 rounded-full bg-hairline overflow-hidden">
            <div
              className="h-full bg-pine rounded-full transition-all duration-400"
              style={{ width: `${Math.min(100, payload.percent)}%` }}
            />
          </div>
          <p className="text-label text-ink-muted mt-2 figure">
            ${Number(payload.current_amount || 0).toLocaleString()} / $
            {Number(payload.target_amount || 0).toLocaleString()}
          </p>
        </div>
      )}

      {metric === 'savings_rate' && payload.points?.length > 0 && (
        <div className="flex items-end gap-1 h-16">
          {payload.points.map((pt) => (
            <div key={pt.month} className="flex-1 flex flex-col items-center gap-1">
              <div
                className="w-full bg-pine/60 rounded-t"
                style={{ height: `${Math.max(8, Math.min(100, pt.savings_rate_pct))}%` }}
                title={`${pt.savings_rate_pct}%`}
              />
              <span className="text-label text-ink-faint truncate w-full text-center">
                {String(pt.month).slice(5)}
              </span>
            </div>
          ))}
        </div>
      )}

      {metric === 'budget_consistency' && (
        <div>
          {payload.consistency_pct != null && (
            <p className="figure text-h2 text-pine mb-2">
              {payload.consistency_pct}% months on plan
            </p>
          )}
          <div className="flex flex-wrap gap-1">
            {(payload.months || []).map((m) => (
              <span
                key={m.month}
                className={`text-label px-2 py-0.5 rounded-full border ${
                  m.on_track
                    ? 'border-pine bg-pine-tint text-pine'
                    : 'border-hairline text-ink-muted'
                }`}
                title={m.note}
              >
                {String(m.month).slice(5)}
              </span>
            ))}
          </div>
          <p className="text-label text-ink-muted mt-2">{payload.label}</p>
        </div>
      )}

      {metric === 'vision_goal' && payload.message && !payload.percent && (
        <p className="text-body text-ink-muted">{payload.message}</p>
      )}
    </AuraCardShell>
  );
};

export default ProgressCardContent;
